import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import MobileBar from "./MobileBar";
import { BUSINESS, PHONE_DISPLAY, PHONE_TEL, EMAIL, SERVICE_AREAS, NAV } from "../data";

const COLS = [
  { title: "Explore", links: [...NAV, { label: "Contact", to: "/contact" }] },
  { title: "Services", links: [
    { label: "Whole-Home Water Treatment", to: "/products" }, { label: "Water Softening", to: "/products" },
    { label: "Well Water Treatment", to: "/products" }, { label: "Reverse Osmosis", to: "/systems-explained" },
  ] },
];

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#172B38] text-[#F4F1E9]/70 pb-16 md:pb-0">
      <div className="wrap pt-20 pb-14 grid gap-12 md:grid-cols-12">
        <div className="md:col-span-4">
          <Logo />
          <p className="mt-7 text-[0.95rem] leading-relaxed max-w-xs">Locally owned water filtration and softening for Northern Virginia homes. We test first and recommend honestly.</p>
        </div>
        {COLS.map((c) => (
          <div key={c.title} className="md:col-span-2">
            <h4 className="text-sm text-[#8CAFC0] mb-5">{c.title}</h4>
            <ul className="space-y-3 text-[0.93rem]">
              {c.links.map((l) => <li key={l.label}><Link to={l.to} className="hover:text-[#F4F1E9] transition-colors">{l.label}</Link></li>)}
            </ul>
          </div>
        ))}
        <div className="md:col-span-4">
          <h4 className="text-sm text-[#8CAFC0] mb-5">Contact</h4>
          <a href={`tel:${PHONE_TEL}`} data-testid="footer-phone" className="block font-heading text-3xl text-[#F4F1E9] hover:text-[#8CAFC0] transition-colors">{PHONE_DISPLAY}</a>
          <a href={`mailto:${EMAIL}`} className="block mt-2 text-[0.93rem] hover:text-[#F4F1E9]">{EMAIL}</a>
          <p className="mt-6 text-[0.9rem] leading-relaxed">Service area: {SERVICE_AREAS.join(", ")} and surrounding Northern Virginia communities.</p>
        </div>
      </div>
      <div className="border-t border-[#F4F1E9]/10">
        <div className="wrap py-6 flex flex-col md:flex-row gap-3 justify-between text-[0.8rem] text-[#F4F1E9]/50">
          <p>© {new Date().getFullYear()} {BUSINESS}. All rights reserved.</p>
          <div className="flex gap-6">
            <Link to="/privacy" data-testid="footer-privacy" className="hover:text-[#F4F1E9]">Privacy Policy</Link>
            <Link to="/terms" data-testid="footer-terms" className="hover:text-[#F4F1E9]">Terms and Conditions</Link>
          </div>
        </div>
      </div>
      <MobileBar />
    </footer>
  );
}
